<template>
  <div class="unUsedCardsWrap">
    <div class="unUsedCards">
      <div v-for="card of cards" :key="card.cardNo" class="unUsedCard">
        <div class="unUsedCardInfo">
          <div class="cardName">{{unionF ? card.kindForeignName : card.kindName}}</div>
          <div v-if="card.type == 2" class="cardTxt">{{ TLang("可用次数", "orderConfirm") }}</div>
          <div v-else class="cardTxt">
            {{ TLang("可用余额", "orderConfirm") }}({{ cardInfo && cardInfo.name ? cardInfo.name : TLang( "福豆", "orderConfirm") }})
          </div>
          <div v-if="card.type == 2" class="cardBalance">
            {{ card.showBalance }}<em>{{ TLang("次", "orderConfirm") }}</em>
          </div>
          <div v-else class="cardBalance">
            {{ formatBalance(card.showBalance)[0]
            }}<em>.{{ formatBalance(card.showBalance)[1] }}</em>
          </div>
          <div class="cardNo">{{ TLang("卡号", "card") }}:{{ card.cardNo }}</div>
          <div class="cardRange">
            <span class="cardTime" v-if="!cardExpireShowType || cardExpireShowType === 1">
              {{ TLang("有效期至", "card") }}{{ formatTime(card.expireDate) }}
            </span>
            <span class="cardTime" v-if="cardExpireShowType === 2">
              {{ TLang("有效期至", "card") }}{{ TLang("长期有效", "card") }}
            </span>
            <span class="cardTips">
              <el-popover
                popper-class="useScope"
                placement="bottom-start"
                title=""
                max-width="300"
                trigger="hover"
                :content="card.kindDesc"
              >
                <el-button slot="reference"
                  ><img :src="require('@/assets/images/order/tips.png')" /><em
                    class="tipTxt"
                    >&nbsp;{{ TLang("使用范围", "orderConfirm") }}</em
                  ></el-button
                >
              </el-popover>
            </span>
          </div>
        </div>
        <el-popover
          v-if="card.unavailableImgUrl && card.unavailableImgUrl.length"
          popper-class="useScope"
          placement="bottom-start"
          title=""
          max-width="300"
          trigger="hover"
          :content="card.unavailableDesc"
        >
          <ul class="box">
            <li v-for="(item, index) of card.unavailableImgUrl" :key="index">
              <img :src="item" class="file-tew" />
            </li>
          </ul>
          <p class="flex-Tips">{{TLang('以上商品本卡暂不支持购买','list')}}</p>
          <div slot="reference" class="unUsedReason">
            <img :src="require('@/assets/images/icon_deliver_tip.png')" />{{
              card.unavailableDesc
            }}
          </div>
        </el-popover>
        <div v-else class="unUsedReason">
          <img :src="require('@/assets/images/icon_deliver_tip.png')" />{{
            card.unavailableDesc
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { unionFlag} from '@utils/index';
export default {
  name: "UnUsedCard",
  props: {
    // 卡数据
    cards: Object,
    interestsInfo: Object,
  },
  data() {
    return {
      unionF: unionFlag() || sessionStorage.getItem('dffl_union'),
      interestsInfos: JSON.parse(JSON.stringify(this.interestsInfo)),
    }
  },
  computed: {
    // 卡信息
    cardInfo() {
      if (this.interestsInfo && this.interestsInfo.cardInfo) {
        return this.interestsInfo.cardInfo;
      }
      return null;
    },
    cardExpireShowType() {
      if (this.interestsInfos && this.interestsInfos.cardExpireShowType) {
        return this.interestsInfos.cardExpireShowType;
      }
      return null;
    },
  },
  methods: {
    formatBalance(balance) {
      if (!balance) {
        return ["0", "00"];
      }
      const newBalance = (balance / 100).toFixed(2);
      return newBalance.split(".");
    },
    formatTime(str) {
      if (!str) {
        return "";
      }
      return str.replace(/\-/g, ".");
    },
  },
};
</script>

<style lang="less" scoped>
.unUsedCardsWrap {
  .unUsedCards {
    padding-left: 24px;
    display: flex;
    flex-wrap: wrap;
  }
  .unUsedCard {
    width: 270px;
    margin-right: 24px;
    margin-bottom: 24px;
  }
  .unUsedCardInfo {
    padding: 12px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    background: #f8fcff;
    background: #f6f6f7;
  }
  .unUsedCard:nth-child(4n) {
    margin-right: 0;
  }
  .cardName {
    max-height: 48px;
    font-size: 16px;
  
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
  }
  .cardTxt {
    padding-top: 12px;
    font-size: 12px;
  
    font-weight: 400;
    color: #333;
  }
  .cardBalance {
    font-size: 24px;
  
    font-weight: 500;
    color: #333;
    em {
      font-size: 12px;
    }
  }
  .cardNo {
    margin: 12px 0;
    font-size: 12px;
  
    color: #666666;
  }
  .cardRange {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  
    color: #666;
  }
  .cardTime {
    text-align: left;
  }
  .cardTips {
    text-align: right;
    img {
      margin-right: -2px;
      width: 12px;
      height: 12px;
      vertical-align: middle;
      margin-top: -1.8px;
    }
    .tipTxt {
      color: #999;
      cursor: pointer;
    }
  }
  .unUsedReason {
    padding: 4px 12px;
    background: #f6f6f7;
    border: 1px solid #e5e5e5;
    border-top: none;
    font-size: 12px;
  
    font-weight: 400;
    color: #f44545;
    img {
      width: 12px;
      height: 12px;
      padding-right: 5px;
      vertical-align: baseline;
    }
  }
}
.useScope {
  font-size: 14px;

  color: #333333;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.box {
  max-width: 350px;
  max-height: 350px;
  padding: 0;
  margin: 0 -10px 0 0;
  overflow: hidden;
  overflow-y: auto;
  li {
    list-style: none;
    float: left;
    width: 60px;
    height: 60px;
    margin-right: 10px;
    margin-bottom: 12px;
  }
}
.flex-Tips {
  color: #999999;
  font-size: 11px;
}
.file-tew {
  width: 60px;
  height: 60px;
}
</style>
